import { createRenderer } from 'fela';
import pseudoClass from 'fela-plugin-friendly-pseudo-class';
import prefixer from 'fela-plugin-prefixer';
import webPreset from 'fela-preset-web';

import { defaultStyles } from '../utils/constants';
import namedKeysPlugin from './fela-named-keys';

export function getFelaRenderer() {
  const renderer = createRenderer({
    // Fela names its atomic classes by counting: a, b, ... ez, fa, fb. Without
    // a prefix those collide with third-party CSS, and the Font Awesome kit
    // ships `.fa, .far, .fas { font-family: "Font Awesome 5 Free" }`. Whichever
    // element got the class `fa` then passed the icon font down to everything
    // inside it. Which element that was changed with every render, so text
    // appeared to lose its font at random.
    selectorPrefix: 'kb-s-',
    plugins: [...webPreset, pseudoClass(), namedKeysPlugin, prefixer()]
  });

  renderer.renderStatic(defaultStyles);

  return renderer;
}
